import { FormikSelect } from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import { useAvailableServersForConfiguration } from '../../../system/useAvailableServersForConfiguration'
import { validate } from './helpers'

export const ServerSelectionsStep = () => {
  const translate = useTranslate()
  const allServers = useAvailableServersForConfiguration()

  return (
    <>
      <p>{translate('branchCreationWizard.serverSelectionStep.description')}</p>
      <FormikSelect
        options={allServers}
        name={validate('server')}
        label={translate('branchCreationForm.server.label')}
        shouldShowClearButton={false}
        renderFn={(server) => server.charAt(0).toUpperCase() + server.slice(1)}
      />
    </>
  )
}
